export default "__VITE_ASSET__BEwtIeCl__"